import React from 'react'
import PropTypes from 'prop-types'
import Responsive from 'react-responsive'
import { Accordion } from '@jsluna/react'
import CheckBox from '../../../Common/Checkbox'
import { getLocalTime } from '../../../../utils/timer'

const Mobile = props => <Responsive {...props} maxWidth={699} />

class FireRollCallRow extends React.Component {
  handleSelect = (checked) => {
    this.props.handleCheckboxChange(checked)
  }

  mobileRow = () => (
    <tr className="ln-c-table__row">
      <td className="ln-u-soft-left c-fire-roll-call-option">
        <CheckBox rowNumber={this.props.row.rowNumber} handleCheckboxChange={checked => this.handleSelect(checked)} />
      </td>
      <td colSpan="5" style={{ width: '100%' }} >
        <Accordion title={this.props.row.fullName} standalone={false} className={'c-fire-roll-call-accordion'} >
          <div>
            <div className="ln-c-table__cell" data-label="Telephone">
              {this.props.row.telephoneNumber}
            </div>
            <div className="ln-c-table__cell" data-label="Company">
              {this.props.row.companyName}
            </div>
            <div className="ln-c-table__cell" data-label="In">
              {getLocalTime(this.props.row.timeIn)}
            </div>
            <div className="ln-c-table__cell" data-label="Out">
              {getLocalTime(this.props.row.timeOut)}

            </div>
          </div>
        </Accordion>
      </td>
    </tr>
  )

  row = () => (
    <tr className="ln-c-table__row">
      <td className="ln-u-soft-left c-fire-roll-call-option">
        <CheckBox rowNumber={this.props.row.rowNumber} handleCheckboxChange={checked => this.handleSelect(checked)} />
      </td>
      <td className="ln-c-table__cell c-fire-roll-call-cell">
        {this.props.row.fullName}
      </td>
      <td className="ln-c-table__cell" data-label="Telephone">
        {this.props.row.telephoneNumber}
      </td>
      <td className="ln-c-table__cell" data-label="Company">
        {this.props.row.companyName}
      </td>
      <td className="ln-c-table__cell" data-label="In">
        {getLocalTime(this.props.row.timeIn)}
      </td>
      <td className="ln-c-table__cell" data-label="Out">
        {getLocalTime(this.props.row.timeOut)}

      </td>
    </tr>
  )

  render = () => (
    <Mobile>
      {(matches) => {
        if (matches) {
          return this.mobileRow()
        }

        return this.row()
      }
      }
    </Mobile>
  )
}

FireRollCallRow.propTypes = {
  row: PropTypes.shape({
    rowNumber: PropTypes.number.isRequired,
    fullName: PropTypes.string.isRequired,
    telephoneNumber: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    timeIn: PropTypes.string.isRequired,
    timeOut: PropTypes.string
  }).isRequired,
  handleCheckboxChange: PropTypes.func.isRequired
}

export default FireRollCallRow



// WEBPACK FOOTER //
// ./src/components/FireRollCall/FireRollCallGrid/FireRollCallRow/index.jsx